import React from "react"

import { StyledBackdrop } from "./Backdrop.styled"

const Backdrop = ({ open }) => <StyledBackdrop open={open} />

export default Backdrop
